module.exports = __webpack_public_path__ + "img/blockchain2.f721461e.gif";